import t from 'tcomb';
import Locale from './Locale';
import Anonymous from './Anonymous';
import Registered from './Registered';
import Verified from './Verified';
import get_bundle from './get_bundle';
import Field from './Field';
import find from 'lodash/collection/find';

const User = t.union([Anonymous, Registered, Verified], 'User');

User.dispatch = function (obj) {
 switch (obj.profile) {
   case 'anonymous' : return Anonymous;
   case 'registered' : return Registered;
   case 'verified' : return Verified;
 }
 return obj.constructor;
};

User.to_fields = function(user, locale) {
  const bundle = get_bundle(locale).user;
  let ret = {};
  for (let field in Field.meta.map ) {
    if (user.hasOwnProperty(field)) {
      switch (field) {
        case 'gender':
          ret[field] = find(bundle.gender_options, function(option) {
            return option[0] === user[field];
          })[1];
          break;
        case 'district':
          const districts = window.require('district/' + user.country);
          ret[field] = find(districts, function(option) {
            return option[0] === user[field];
          })[1];
          break;
        case 'birth_date':
          ret[field] = locale.format_date(user[field]);
          break;
        case 'country':
          ret[field] = locale.display_country(user[field]);
          break;
        default:
          ret[field] = user[field];
      }
    }
  }
  return ret;
};

User.of = (user) => {
  if ( ['registered', 'verified'].indexOf(user.profile) !==  -1 ) {
    user.com_locale = Locale.of(user.com_locale);
  }
  return User(user);
};

export default User;




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/User.js
 **/